module.exports = __webpack_public_path__ + "media/images/proof_links/colored/imdb-2e1710cf20f936be38185d9ec267d68e.svg";